module.exports = __webpack_public_path__ + "static/ELEMENTS-9b1cadc944f99dc205d704dfd90efb4a.png";